import { render, staticRenderFns } from "./CommodityManage.vue?vue&type=template&id=7c066bcf&scoped=true"
import script from "./CommodityManage.vue?vue&type=script&lang=js"
export * from "./CommodityManage.vue?vue&type=script&lang=js"
import style0 from "./CommodityManage.vue?vue&type=style&index=0&id=7c066bcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c066bcf",
  null
  
)

export default component.exports